import { createContext, useContext, useState } from "react";

const OportunidadesContext = createContext();

export function OportunidadesProvider({ children }) {
  const [oportunidades, setOportunidades] = useState([]);
  const [selectedOportunidade, setSelectedOportunidade] = useState(null);

  const destacarOportunidade = (id) => {
    setOportunidades((prev) =>
      prev.map((o) =>
        o.id === id ? { ...o, destaque: true } : { ...o, destaque: false }
      )
    );
  };

  const deleteOportunidade = (id) => {
    setOportunidades((prev) => prev.filter((o) => o.id !== id));
  };

  return (
    <OportunidadesContext.Provider
      value={{
        oportunidades,
        setOportunidades,
        selectedOportunidade,
        setSelectedOportunidade,
        destacarOportunidade,
        deleteOportunidade,
      }}
    >
      {children}
    </OportunidadesContext.Provider>
  );
}

export function useOportunidades() {
  return useContext(OportunidadesContext);
}
